import { BaseIcon } from './BaseIcon';

const SearchIcon = (props) => {
  return (
    <BaseIcon {...props}>
      <path
        d="M13.3891 13.7958L19 19.4067M9.5 15.4067C12.5376 15.4067 15 12.9443 15 9.90674C15 6.86917 12.5376 4.40674 9.5 4.40674C6.46243 4.40674 4 6.86917 4 9.90674C4 12.9443 6.46243 15.4067 9.5 15.4067Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

export default SearchIcon;
